// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a6acfb8f","455":"71553538","977":"d8961ec8"}[chunkId] + ".chunk.js";
};